import React, { useContext } from "react";
import styled from "styled-components";
import { TranslationContext } from "../../../../Providers/TranslationProvider";

const Files = styled.div`
    padding: 24px 0px;
    width: 100%;
`;

const FileTitle = styled.h6`
    margin-bottom: 12px;
`;

const IconCon = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
        font-size: 1.7rem;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
`;

const TdImg = styled.td`
    width: 20%;
    img {
        max-height: 130px;
        max-width: 130px;
    }
`;

const FileTable = ({ files, onDeleteFile }) => {
    const { trans } = useContext(TranslationContext);

    const openImage = src => {
        var image = new Image();
        image.src = src
        var w = window.open("");
        w.document.write(image.outerHTML);
        w.document.close()
    };

    if (files && files.length > 0) {
        return (
            <Files>
                <FileTitle>{trans("files", true)}:</FileTitle>
                <table className="w-full">
                    <thead className="text-left">
                        <tr>
                            <th>{trans("preview", true)}</th>
                            <th>{trans("file_name", true)}</th>
                            <th width="50">{trans("delete", true)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {files.map(file => (
                            <tr key={file.value}>
                                <TdImg className="py-2">
                                    <img
                                        style={{cursor: 'pointer'}}
                                        onClick={() =>
                                            openImage(
                                                `data:image/jpg;base64, ${
                                                    file.thumb
                                                }`
                                            )
                                        }
                                        src={`data:image/jpg;base64, ${
                                            file.thumb
                                        }`}
                                        alt=""
                                    />
                                </TdImg>
                                <td>{file.name}</td>
                                <td>
                                    <IconCon>
                                        <i
                                            onClick={() =>
                                                onDeleteFile(file.value)
                                            }
                                            className="fas fa-times"
                                        />
                                    </IconCon>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Files>
        );
    } else {
        return null;
    }
};

export default FileTable;

// const getBase64 = (file) => {
// 	return new Promise((resolve, reject) => {
// 	  const reader = new FileReader();
// 	  reader.readAsDataURL(file);
// 	  reader.onload = () => resolve(reader.result);
// 	  reader.onerror = error => reject(error);
// 	});
//   }
